componentRegistryInstance.register('chart', 'read', 'hrd.components.form.ChartComponent');

hrd.components.form.ChartComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.ChartComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	reEnhanceReadField: function(field, id) {
		this.enhanceReadFieldInner(field, id);
	},
	
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, 'chart-field ignore-for-fhs');
		this.enhanceReadFieldInner(field, id);
	},
	enhanceReadFieldInner: function(field, id) {
		// set the container height, so that it can be possible to have a good height
		var ignoreFH = field.data('ignoreFullHeight');
		var useRemainingHeight = field.data('useRemainingHeight');
		if (!ignoreFH && !useRemainingHeight) {
			field.closest('.field-composite').addClass('full-height');
			field.closest('.fieldset').addClass('full-height');
		}
		if (useRemainingHeight) {
			/* force this .fieldset height to be all the available space left by other .fieldset */
			$.timeout(0).then(() => {
				var $fieldset = field.closest('fieldset');
				var thisFieldset = field.closest('.fieldset');

				/* iterates over all .fieldset elements to compute a dynamic 'id' */
				$('.fieldset', $fieldset).each((i, fs) => $(fs).uniqueId());

				var thisFieldsetId = thisFieldset.attr('id');
				var totalFieldsetHeight = $fieldset.height();

				var thisFieldsetHeight = $('.fieldset', $fieldset).toArray()
					.reduce((intermediate, fs) => {
						var $fs = $(fs);
						var h = $fs.outerHeight(true) - ($fs.attr('id') == thisFieldsetId ? $fs.height() : 0);
						return intermediate - h;
					}, totalFieldsetHeight);
				field.closest('.fieldset').height(thisFieldsetHeight)
				field.closest('.field-composite').addClass('full-height');
			});
		}
		let chart = field.data('chart');
		if (chart != undefined) {
			let reference = this.settings.reference;
			chartInfo = $.evaluate(chart, reference || this.getFormInstance()); // se non c'è reference passa il form
			field.data('chartInfo', chartInfo);
			if (chartInfo.provider && chartInfo.method) {
				if (chartInfo.loading == undefined) {
					var extraParams = (typeof chartInfo.extraParams === 'function') ? chartInfo.extraParams.apply(reference) : chartInfo.extraParams;
					var chartPromise = dashboardInstance.invokeProvider(chartInfo.provider, chartInfo.method, extraParams)
						.then((data) => {
							var chartInfo = field.data('chartInfo')
							var chartObject = hrd.charts.Factory({ id: `#${id}` }, data, chartInfo.extraOptions, chartInfo.customImpl);
							chartObject.settings.container = reference;
							chartObject.settings.chartInfo = chartInfo;
							field.data('chartObject', chartObject);
							chartObject.postInit();
						});
					this.addEnhancePhasePromise(chartPromise);
				}
			} else {
				console.log('Provider or method are missing', chartInfo.provider, chartInfo.method, chart);
			}
		}
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	setReadOnlyField: function(field, value, object, options) {
		// do nothing: do not call 'super'
		// for the moment, nothing to do. to be verified in future
	},
	resetReadOnlyField: function(field, options) {
		// do nothing: do not call 'super'
		// for the moment, nothing to do. to be verified in future
	}
});